import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission, isSocialCreative } from "utils/common";
import { CV, VERSION_STATUS } from "utils/constants";
import { Button } from "rhombus-react";
import { socialPublishVersion } from "reducers/CreativeVersions";

export default function PublishSocialVersionsButton({ libraryId }) {
	const dispatch = useDispatch();
	const { currentSelection, versions, creativeDetails, user } = useSelector((state) => {
		return {
			currentSelection: state.selected.versions,
			versions: state.creativeVersions.items,
			creativeDetails: state.creativeDetails,
			user: state.you,
		};
	});

	const { adType } = creativeDetails;

	const unpublishedVersionIds = useMemo(() => {
		return versions.reduce((prev, version) => {
			if (currentSelection.includes(version.id) && version.status === VERSION_STATUS.UNPUBLISHED) {
				return [...prev, version.id];
			}
			return prev;
		}, []);
	}, [versions, currentSelection]);

	const handleClick = () => {
		dispatch(socialPublishVersion(unpublishedVersionIds));
	};

	const showButton = [
		isSocialCreative({ adType }),
		unpublishedVersionIds.length,
		hasPermission(user, CV, "Manage Version Library"),
	].every(item => item);

	// Conditional Render
	if (!showButton) {
		return null;
	}

	return (
		<Button
			icon="upload"
			style="block"
			onClick={handleClick}
		>
			Publish ({unpublishedVersionIds.length})
		</Button>
	);
}
